module.exports = __webpack_public_path__ + "nz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/nz.svg
// module id = 998
// module chunks = 0